// redux/tabsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeTab: 'plan', // начальная вкладка
};

const tabsSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload; // меняем активную вкладку
    },
  },
});

export const { setActiveTab } = tabsSlice.actions;
export default tabsSlice.reducer;
